const DEV_COOKIE = 'dvp-pharmacist-enc';
const PROD_COOKIE = 'pdt-pharmacist-enc';

export const serviceTokenMap = {
  DEV: DEV_COOKIE,
  PRODUCTION: PROD_COOKIE
} as const;
